/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:53:04]
Permissions to update outside the main branch: [false]
*/

import { DropDown, DropDownList, Input, useGridFilterUrlContext } from '@finbeat/react-toolkit';
import { getTypesList } from 'axios/userActionLogApi';
import { BODatePicker } from 'base-components/BODatePicker/BODatePicker';
import useApi from 'hooks/useApi';
import { ActionLogRequestFilter } from 'models/api/actionLog';
import { ChangeEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { Col, FormGroup, Row } from 'reactstrap';

const UserActionLogFilter = () => {
    const { draftFilter, setDraftFilter } = useGridFilterUrlContext<ActionLogRequestFilter>();
    const { t } = useTranslation();
    const api = useApi();

    const [typeList, setTypeList] = useState<DropDown[]>([]);

    const changeInputProp = (e: ChangeEvent<HTMLInputElement>) =>
        changeProp(e.target.value, e.target.name);

    const getDictListQuery = useQuery('userActionTypesList', () => getTypesList(api), {
        onSuccess: (data) => {
            setTypeList(data);
        },
        enabled: typeList == null || typeList.length === 0,
    });

    const changeProp = (value: string | DropDown, name: string) => {
        const updatedValue = (
            typeof value === 'string' ? { [name]: value } : { [name]: value.name }
        ) as ActionLogRequestFilter;
        setDraftFilter((prev) => ({ ...prev, ...updatedValue }));
    };

    const {
        sd = '',
        ed = '',
        type = '',
        controller = '',
        action = '',
        actionParams = '',
        statusCode = '',
        response = '',
    } = draftFilter;

    return (
        <>
            <Row>
                <Col>
                    <BODatePicker
                        id="ds-start-date"
                        value={sd}
                        onChange={(val) =>
                            setDraftFilter((prevState) => ({ ...prevState, sd: val }))
                        }
                        inputProps={{ label: t('BackOfficeStartDate') }}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <BODatePicker
                        id="ds-start-date"
                        value={ed}
                        onChange={(val) =>
                            setDraftFilter((prevState) => ({ ...prevState, ed: val }))
                        }
                        inputProps={{ label: t('BackOfficeStartDate') }}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormGroup>
                        <DropDownList
                            label={t('BackOfficeType')}
                            value={type}
                            name="type"
                            setValue={(value) => changeProp(value, 'type')}
                            isLoading={getDictListQuery.isFetching}
                            items={typeList}
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Input
                        id="ds-controller"
                        value={controller}
                        name="controller"
                        onChange={changeInputProp}
                        label={t('BackOfficeController')}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <Input
                        id="ds-action"
                        value={action}
                        name="action"
                        onChange={changeInputProp}
                        label={t('BackOfficeMethodControllerAction')}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <Input
                        id="ds-action-params"
                        value={actionParams}
                        name="actionParams"
                        onChange={changeInputProp}
                        label={t('BackOfficeActionParams')}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <Input
                        id="ds-status-code"
                        value={statusCode}
                        name="statusCode"
                        onChange={changeInputProp}
                        label={t('BackOfficeStatusCode')}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <Input
                        id="ds-response"
                        value={response}
                        name="response"
                        onChange={changeInputProp}
                        label={t('BackOfficeResponse')}
                    />
                </Col>
            </Row>
        </>
    );
};

export default UserActionLogFilter;
